export const toTimeString = (minutes, fallback = 6) => {
  const parsed = Number.parseInt(minutes, 10);
  const safeMinutes = Number.isNaN(parsed) ? fallback : Math.max(parsed, 0);
  return safeMinutes < 10 ? `00:0${safeMinutes}` : `00:${safeMinutes}`;
};

export const toMinutes = (time, fallback = 6) => {
  if (!time || typeof time !== "string") return fallback;
  const chunks = time.split(":");
  const minutes = Number.parseInt(chunks?.[1], 10);
  return Number.isNaN(minutes) ? fallback : minutes;
};

export const buildStationPayload = (data, subStations) => {
  const payload = {
    name: data.title,
    midnight_autocomplete: data.midnight_autocomplete,
    is_multi: data.is_multi,
    info: data.info,
    order_restriction: toTimeString(data.restriction, 0),
    baseline_time: toTimeString(data.baseline_time, 6),
    order_max_threshold:
      data.order_max_threshold !== undefined &&
      data.order_max_threshold !== ""
        ? Number(data.order_max_threshold)
        : null,
    order_min_threshold:
      data.order_min_threshold !== undefined &&
      data.order_min_threshold !== ""
        ? Number(data.order_min_threshold)
        : null,
  };
  if (subStations.length > 0) payload.sub_stations = subStations;
  return payload;
};
